import type { HTMLAttributes } from 'react';

import { cssClasses } from 'pkg/css/utils';

import * as styles from './styles.css';

interface ToggleProps extends HTMLAttributes<HTMLDivElement> {
	active: boolean;
}

const Toggle = ({ active, className, ...props }: ToggleProps) => {
	return (
		<div
			className={cssClasses(styles.toggle, active && styles.active, className)}
			{...props}
		/>
	);
};

export default Toggle;
